import {
  CONFIGURATION_CHANGE_REQUEST_ADDED,
  CONFIGURATION_CHANGE_REQUEST_DELETED,
  CONFIGURATION_CHANGE_REQUEST_EDITED,
  CONFIGURATION_CHANGE_REQUEST_SET,
} from 'src/app/redux/redux-types';
import { reduxConfigurationChangeRequestTypes } from 'src/types';

export const configurationChangeRequestDefaultState: reduxConfigurationChangeRequestTypes.StateType = {
  configurationChangeRequestList: [],
  isCCRFetchRequestCompleted: false,
};

export const configurationChangeRequestReducer = (
  state = configurationChangeRequestDefaultState,
  action: reduxConfigurationChangeRequestTypes.ActionType,
): reduxConfigurationChangeRequestTypes.StateType => {
  switch (action.type) {
    case CONFIGURATION_CHANGE_REQUEST_SET:
      return {
        ...state,
        configurationChangeRequestList: action.payload.list,
        isCCRFetchRequestCompleted: action.payload.isCCRFetchRequestCompleted,
      };
    case CONFIGURATION_CHANGE_REQUEST_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.configurationChangeRequestList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        configurationChangeRequestList: [action.payload, ...state.configurationChangeRequestList],
      };
    case CONFIGURATION_CHANGE_REQUEST_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.configurationChangeRequestList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        configurationChangeRequestList: [
          ...state.configurationChangeRequestList.slice(0, updateIndex),
          action.payload,
          ...state.configurationChangeRequestList.slice(updateIndex + 1),
        ],
      };
    case CONFIGURATION_CHANGE_REQUEST_DELETED:
      return {
        ...state,
        configurationChangeRequestList: state.configurationChangeRequestList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
